var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9334 6.06603C15.9334 8.86344 13.6652 11.132 10.8673 11.132C8.0695 11.132 5.80176 8.86344 5.80176 6.06603C5.80176 3.26861 8.0695 1 10.8673 1C13.6652 1 15.9334 3.26861 15.9334 6.06603Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6698 17.1589C18.1716 13.6171 14.6642 11.1321 10.5771 11.1321C6.06121 11.1321 2.25354 14.1655 1.08122 18.3069C0.698846 19.6569 1.71474 21 3.11823 21H10.445",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77518 17.1589C3.27339 13.6171 6.7808 11.1321 10.8679 11.1321C15.3838 11.1321 19.1915 14.1655 20.3638 18.3069C20.7462 19.6569 19.7303 21 18.3268 21H11",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6698 17.1589C18.1716 13.6171 14.6642 11.1321 10.5771 11.1321C6.06121 11.1321 2.25354 14.1655 1.08122 18.3069C0.698846 19.6569 1.71474 21 3.11823 21H10.445M1.77518 17.1589C3.27339 13.6171 6.7808 11.1321 10.8679 11.1321C15.3838 11.1321 19.1915 14.1655 20.3638 18.3069C20.7462 19.6569 19.7303 21 18.3268 21H11",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountFilled);
export default __webpack_public_path__ + "static/media/account-filled.f2082298ed766d631a793fd22891fa8f.svg";
export { ForwardRef as ReactComponent };